module.exports = __webpack_public_path__ + "img/info-symbol-hover.144a2b81.svg";